import cleanString from './cleanString'

export const createWebpageSchema = ({ pageTitle, pageDescription, pageUrl, breadcrumbs }) => {
  if (!pageTitle || !pageUrl) {
    return null
  }

  let breadcrumbsList = ''
  if (breadcrumbs && Array.isArray(breadcrumbs) && breadcrumbs.length > 0) {
    breadcrumbsList = `{
      "@type": "BreadcrumbList",
       "itemListElement": [${breadcrumbs.map(
         (breadcrumb, index) => `{
        "@type": "ListItem",
        "position": ${index + 1},
        "item": {
          "@id" : "${process.env.GATSBY_HELIGUY_DOMAIN}${breadcrumb.pathname}",
          "name": "${cleanString(breadcrumb.crumbLabel) === '?' ? cleanString(pageTitle) : cleanString(breadcrumb.crumbLabel)}"
        }
      }`
       )}]
    }`
  }

  return `{
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "${cleanString(pageTitle)}",
  "description": "${pageDescription ? cleanString(pageDescription) : 'No Description'}",
  ${breadcrumbsList && breadcrumbsList.length ? `"breadcrumb":${breadcrumbsList},` : ''}
  "url": "${pageUrl}"
}`
}
